import { useSearchParams } from "react-router-dom";

const SurveyForm = () => {
  const [searchParams] = useSearchParams(); // Correct hook usage
  const phone = searchParams.get("phone"); // Get phone param

  const feedbackUrl = `https://amigo.emotorad.com/feedback2?phone=${encodeURIComponent(
    phone
  )}`;

  return (
    <>
      <iframe
        src={feedbackUrl}
        style={{ width: "100%", height: "100vh", border: "none" }}
        title="Feedback Survey"
      />
    </>
  );
};

export default SurveyForm;
